import './shop-tabs.scss';

import { useTranslation } from 'react-i18next';

import BagIcon from '@/shared/assets/icons/bag.svg?react';
import GiftIcon from '@/shared/assets/icons/gift.svg?react';
import ShopIcon from '@/shared/assets/icons/shop.svg?react';

import type { ShopTab } from '../../types';

type ShopTabsProps = {
  active: ShopTab;
  onChange: (tab: ShopTab) => void;
};

export function ShopTabs({ active, onChange }: ShopTabsProps) {
  const { t } = useTranslation();

  return (
    <div className="shop-tabs">
      <button
        className={`shop-tabs__tab${active === 'shop' ? ' shop-tabs__tab--active' : ''}`}
        onClick={() => onChange('shop')}>
        <ShopIcon className="shop-tabs__icon" />
        <span className="shop-tabs__label">{t('shop.tabShop')}</span>
      </button>
      <button
        className={`shop-tabs__tab${active === 'gifts' ? ' shop-tabs__tab--active' : ''}`}
        onClick={() => onChange('gifts')}>
        <GiftIcon className="shop-tabs__icon" />
        <span className="shop-tabs__label">{t('shop.tabGifts')}</span>
      </button>
      <button
        className={`shop-tabs__tab${active === 'inventory' ? ' shop-tabs__tab--active' : ''}`}
        onClick={() => onChange('inventory')}>
        <BagIcon className="shop-tabs__icon" />
        <span className="shop-tabs__label">{t('shop.tabInventory')}</span>
      </button>
    </div>
  );
}
